export const getEmotionColor = (emotion) => {
  if (["sad", "tired", "lonely"].includes(emotion)) return "bg-[#F8FBFD]";
  if (["scared", "angry", "stressed"].includes(emotion)) return "bg-[#FCFAFE]";
  if (["grateful", "calm", "happy"].includes(emotion)) return "bg-[#F8FDFA]";
  return "bg-white";
};

const EMOJI_MAP = [
  ["sad", "images/emotions/sad.png"],
  ["tired", "images/emotions/tired.png"],
  ["lonely", "images/emotions/lonely.png"],
  ["happy", "images/emotions/happy.png"],
  ["grateful", "images/emotions/grateful.png"],
  ["calm", "images/emotions/calm.png"],
  ["stressed", "images/emotions/stressed.png"],
  ["scared", "images/emotions/scared.png"],
  ["angry", "images/emotions/angry.png"],
  ["all emotions", "images/emotions/all_emotions.png"]
];

export const getEmojiImage = (emotion) => {
  const match = EMOJI_MAP.find(([key]) => key === emotion);
  return match ? match[1] : null;
};

export const emotionEmojiImgMapping = {
  sad: "/images/emotions/sad.png",
  tired: "/images/emotions/tired.png",
  lonely: "/images/emotions/lonely.png",
  happy: "/images/emotions/happy.png",
  grateful: "/images/emotions/grateful.png",
  calm: "/images/emotions/calm.png",
  stressed: "/images/emotions/stressed.png",
  angry: "/images/emotions/angry.png",
  scared: "/images/emotions/scared.png",
};

export const emotionGroups = [
  {
    label: "Blue Emotions",
    color: "#F8FBFD",
    emotions: ["sad", "tired", "lonely"],
  },
  {
    label: "Green Emotions",
    color: "#FCFAFE",
    emotions: ["happy", "grateful", "calm"],
  },
  {
    label: "Purple Emotions",
    color: "#F8FDFA",
    emotions: ["stressed", "angry", "scared"],
  },
];